module.exports = __webpack_public_path__ + "img/about-dots-mobile.79cafe14.svg";